import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, Image } from "react-native";
import { useTranslation } from "react-i18next";
import SvaraModal from "./SvaraModal";
import { BtnCloseModal, ProfileChipPng } from "../../../assets";
import { useDevice } from "../../../utils/hooks/useDevice";

interface IProps {
  onClose: () => void;
  roomName: string;
  roomUnlockCost: number;
  minLevel: number;
  lockImages: {
    lock4_1: any;
    lock4_2: any;
  };
}

const UnlockRoomModal: React.FC<IProps> = ({
  onClose,
  roomName,
  roomUnlockCost,
  minLevel,
  lockImages,
}) => {
  const { t } = useTranslation();
  const { isDesktop, isXs } = useDevice();

  const handleUnlock = () => {
    // TODO: Implement unlock functionality
    console.log("Unlock room:", roomName);
  };

  return (
    <SvaraModal
      visible
      onClose={onClose}
      closeIcon={BtnCloseModal}
      closeButtonSize="big"
      closeButtonStyles={{
        width: 42,
        height: 42,
        ...(isXs && { transform: [{ translateX: 11 }, { translateY: -10 }] }),
      }}
    >
      <View style={[styles.container, { width: isDesktop ? 500 : 340 }]}>
        <View style={styles.content}>
          {/* Lock Icon */}
          <View style={styles.lockContainer}>
            <Image
              source={lockImages.lock4_1}
              style={styles.lockBaseIcon}
              resizeMode="contain"
            />
            <Image
              source={lockImages.lock4_2}
              style={styles.lockTextIcon}
              resizeMode="contain"
            />
          </View>

          {/* Title */}
          <Text style={styles.title}>Room Locked</Text>

          {/* Main Message */}
          <View style={styles.messageBox}>
            <Text style={styles.messageText}>
              You need at least{" "}
              <Text style={styles.highlight}>level {minLevel}</Text> to play in
              this room!
            </Text>
          </View>

          {/* Description Box */}
          <View style={styles.descriptionBox}>
            <Text style={styles.descriptionText}>
              You can unlock{" "}
              <Text style={styles.roomNameHighlight}>{roomName}</Text> room for
            </Text>
            <View style={styles.priceContainer}>
              <Text style={styles.priceText}>${roomUnlockCost}</Text>
              <Image
                source={ProfileChipPng}
                style={styles.chipIcon}
                resizeMode="contain"
              />
            </View>
          </View>

          {/* Buttons */}
          <View style={styles.buttonsContainer}>
            <TouchableOpacity
              style={[styles.button, styles.closeButton]}
              onPress={onClose}
              activeOpacity={0.8}
            >
              <Text style={styles.buttonText}>Close</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.unlockButton]}
              onPress={handleUnlock}
              activeOpacity={0.8}
            >
              <Text style={styles.buttonText}>Unlock</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </SvaraModal>
  );
};

export default UnlockRoomModal;

const styles = StyleSheet.create({
  container: {
    maxHeight: "85%",
  },
  content: {
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  lockContainer: {
    width: 100,
    height: 100,
    marginBottom: 15,
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
  },
  lockBaseIcon: {
    position: "absolute",
    width: "80%",
    height: "80%",
    opacity: 0.8,
  },
  lockTextIcon: {
    position: "absolute",
    width: "80%",
    height: "80%",
    opacity: 0.8,
  },
  title: {
    color: "#fff",
    fontSize: 24,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 20,
    textTransform: "uppercase",
  },
  messageBox: {
    width: "100%",
    backgroundColor: "rgba(255, 0, 0, 0.15)",
    borderRadius: 8,
    paddingVertical: 15,
    paddingHorizontal: 20,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: "rgba(255, 0, 0, 0.3)",
  },
  messageText: {
    color: "#fff",
    fontSize: 16,
    textAlign: "center",
    lineHeight: 24,
  },
  highlight: {
    color: "#ffa100",
    fontWeight: "bold",
    fontSize: 18,
  },
  descriptionBox: {
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    borderRadius: 8,
    paddingVertical: 15,
    paddingHorizontal: 20,
    marginBottom: 30,
    alignItems: "center",
  },
  descriptionText: {
    color: "#fff",
    fontSize: 15,
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 10,
  },
  roomNameHighlight: {
    color: "#0089d7",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  priceContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 5,
  },
  priceText: {
    color: "#FFD700",
    fontSize: 24,
    fontWeight: "bold",
    marginRight: 8,
  },
  chipIcon: {
    width: 28,
    height: 28,
  },
  buttonsContainer: {
    flexDirection: "row",
    width: "100%",
    gap: 15,
  },
  button: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  closeButton: {
    backgroundColor: "#666",
  },
  unlockButton: {
    backgroundColor: "#0089d7",
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "700",
    textTransform: "uppercase",
  },
});
